export default function TeamTile(props) {
  return (
    <div className='team-div section-border-top'>
      <div className='tile-title-container'>
        <img className='team-tile-img section-border-bottom' src={props.image}></img>
        <div className='team-tile-name'>{props.name}</div>
      </div>
        <div className='team-tile-title'>{props.title}</div>
        <div className='tile-margins text'>{props.description}</div>
    </div>
  );
}